import 'angular-ui-bootstrap/src/tabs/tabs';

import tabTemplate from './tab.jade';
import tabsetTemplate from './tabset.jade';

export default angular.module('ui.cian.tabs.adapter',
	['ui.bootstrap.tabs'])
	.run(['$templateCache', ($templateCache) => {
		$templateCache.put('uib/template/tabs/tab.html', tabTemplate);
		$templateCache.put('uib/template/tabs/tabset.html', tabsetTemplate);
	}])
	.name;
